<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start">
            <h1 class="mx-1">Istoric document oficial</h1>

        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col">
            <table datatable [dtOptions]="dtOptions" class="row-border hover">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Număr</th>
                        <th>Data</th>
                        <!-- <th>ID Document</th>
                        <th>ID Cerere</th>
                        <th>Tip Registru</th> -->
                        <th>Nume Utilizator</th>
                        <th>Dată</th>
                        <th>Denumire Acțiune</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of data">
                        <td>{{ item.id }}</td>
                        <td>{{ item.numar }}</td>
                        <td>{{ item.data }}</td>
                        <!-- <td>{{ item.document_id }}</td>
                        <td>{{ item.cerere_id }}</td>
                        <td>{{ item.reg_type}}</td> -->
                        <td>{{ item.user_name }}</td>
                        <td>{{ item.created_at | date: "yyyy-MM-dd HH:mm" }}</td>
                        <td>{{ item.user_action_name }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>